import { InputGroup, InputLeftAddon, Icon, Box, Grid } from '@chakra-ui/react';
import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { IconSort } from 'assets/icons';
import ReactSelect from 'components/ReactSelect';
import SearchField from 'components/SearchField';

interface IFilterGroupProps {
  handleSortChange?: (selectedValue: ILabelValueOptions) => void;
  handleSearchInputChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  entity?: 'Job' | 'Task';
}

const FilterGroup: React.FC<IFilterGroupProps> = ({ handleSortChange, handleSearchInputChange, entity }) => {
  const { t } = useTranslation(['jobsTasks', 'common']);

  const sortOptions = useMemo(
    () => [
      { label: t('jobsTasks:jobsTaskName', { entity: entity }), value: 'name' },
      { label: 'Date Created', value: 'created_at' },
    ],
    [entity, t]
  );

  return (
    <Grid
      templateColumns={{ base: '1fr', sm: 'repeat(2, 1fr)', md: '230px 1fr' }}
      gap="4"
      sx={{ '.valueContainerWrapper': { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 } }}
    >
      <InputGroup mr="3">
        <InputLeftAddon children={<Icon as={IconSort} height="20px" width="20px" />} px="2" />
        <ReactSelect
          options={sortOptions}
          variant="outline"
          isClearable
          isSearchable
          placeholder="Sort by"
          onChange={handleSortChange}
        />
      </InputGroup>

      <Box ml="auto" maxWidth={{ md: '350px' }} width="100%">
        <SearchField
          inputProps={{
            placeholder: t('jobsTasks:searchJobsTasks', { entity: entity }),
            onChange: handleSearchInputChange,
          }}
        />
      </Box>
    </Grid>
  );
};

export default memo(FilterGroup);
